import { useAuth } from '../stores/auth'

export function SubscriptionGuard({ children }: { children: React.ReactNode }) {
  const { org } = useAuth()

  if (!org) return null

  const trialExpired = org.subscription_status === 'trialing' && org.trial_ends_at && new Date(org.trial_ends_at) < new Date()

  if (trialExpired || org.subscription_status === 'past_due' || org.subscription_status === 'cancelled') {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-6">
        <div className="max-w-md text-center space-y-6">
          <div className="text-6xl">&#9200;</div>
          <h1 className="text-2xl font-bold text-white">
            {trialExpired ? 'Testphase abgelaufen' : 'Abo nicht aktiv'}
          </h1>
          <p className="text-white/60">
            {trialExpired
              ? 'Deine 30-tägige Testphase ist abgelaufen. Wähle einen Plan, um weiterzumachen.'
              : 'Dein Abonnement ist nicht aktiv. Bitte aktualisiere deine Zahlungsinformationen.'}
          </p>
          <a href="/settings" className="inline-block px-6 py-3 bg-white text-black rounded-lg font-medium hover:bg-white/90 transition-colors">
            Plan wählen
          </a>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
